import { ListItemText, ListSubheader } from "@mui/material";
import { KeyboardEvent } from "react";
import {
  ConditionTagBaseMenuItem,
  BaseMenuItemProps,
} from "./ConditionTagBaseMenuItem";

export type MenuItemsGroupProps = {
  groupTitle: string;
  items: Array<BaseMenuItemProps>;
  onClick?: (value: string) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLLIElement>, label: string) => void;
};

export const ConditionTagMenuItemsGroup = ({
  items,
  groupTitle,
  onClick,
  onKeyDown,
}: MenuItemsGroupProps) => {
  return (
    <>
      <ListSubheader
        sx={{
          backgroundColor: "background.default",
          mt: 3,
          mb: 1,
          px: 3,
          lineHeight: "16px",
          fontSize: "12px",
          pointerEvents: "none",
        }}
      >
        {groupTitle}
      </ListSubheader>
      {items.map((item) => {
        return (
          <ConditionTagBaseMenuItem
            label={item.label}
            value={item.value}
            onClick={onClick}
            key={item.label}
            onKeyDown={(event) => onKeyDown?.(event, item.value)}
          >
            <ListItemText primary={item.label} />
          </ConditionTagBaseMenuItem>
        );
      })}
    </>
  );
};
